(function () {
  'use strict';

  angular
    .module('app')
    .service('TransportationInventoryModalService', TransportationInventoryModalService);

  TransportationInventoryModalService.$inject = ['ModalService'];

  function TransportationInventoryModalService(ModalService) {
    var service = {
      openTransportationInventoryModal: openTransportationInventoryModal,
    };

    return service;

    ///////////////////////

    function openTransportationInventoryModal(item, successCallback) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/transportation-inventories/modals/transportation-inventory-modal.html',
        controller: TransportationInventoryModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      TransportationInventoryModalCtrl.$inject = ['$element', 'item', 'successCallback'];
    }

    function TransportationInventoryModalCtrl($element, item, successCallback) {
      var vm = this;

      vm.item = item;

      vm.modalTitle = 'UPDATE_INVENTORY';

      vm.onInventorySaved = onInventorySaved;

      function onInventorySaved() {
        $element.modal('hide');
        successCallback();
      }
    }
  }
})();
